import * as $ from 'jquery';
import * as _ from 'lodash';
import { ModuleLayoutCollection } from '../../../../../collections/ModuleLayout';
import { ModuleCollection } from '../../../../../collections/Modules';
import { Utils } from "../../../../../common/utils";
import { DashboardChannel } from '../../../../../models/DashboardChannel';
import { BaseModifyDashboardWidgetView } from "../_BaseModifyWidgetView";

declare var App: any;

export class ModifyModuleLayoutWidget extends BaseModifyDashboardWidgetView {

    private widgetChannels: DashboardChannel[];

    private template = _.template(require('templates/modals/dashboard/modify_widgets/layout/layout.html'));
    private channelsTemplate = _.template(require('templates/modals/dashboard/modify_widgets/simplewidget/simplewidgetchannels.html'));
    ModuleLayoutCollection: ModuleLayoutCollection;

    constructor(options) {
        super(<any>_.extend({
            tagName: "div",
            events: {
                'click .add-channel-btn': 'handleAddChannelBtnClick',
                'change .widget-channel-select-install': 'handleInstallSelectChange',
                'change .widget-channel-select-module': 'handleModuleSelectChange',
                'change .widget-layout-select-install': 'handleLayoutInstallSelectChange',
                'change .widget-channel-select-channel': 'handleChannelSelectChange',
                'click .widget-channel-delete': 'handleChannelDelete',
                'click .thresholds-minimized': 'handleThresholdClick',
                'input .thresholds input': 'handleThresholdsInput',
                'change .custom-labels-config-checkbox': 'handleCustomLabelsToggleChange',

                // Ranges
                'change .advanced-config-checkbox': 'handleConfigToggleChange',
                'click .add-threshold-btn': 'handleAddThreshold',
                'click .delete-threshold-btn, .delete-threshold-btn-mobile': 'handleDeleteThreshold',
                'input .threshold-name, .threshold-value': 'handleThresholdInput',
                'click .use-defaults-btn': 'handleUseDefaultsBtn',
                'change .tab select': 'handleTabChange',
            }
        }, options));
        if (!this.options.widget) {
            this.options.widget = new this.options.dashboardWidgetCollection.model({
                dashboard_id: this.options.dashboardId,
                params: []
            });
        }

        this.widgetChannels = null;
        if (!this.options.widget) {
            this.options.widget = new this.options.dashboardWidgetCollection.model({
                dashboard_id: this.options.dashboardId,
                params: [{
                    key: 'WIDGET_SIZE',
                    value: '6'
                }]
            });
            this.widgetChannels = [];
        } else {
            this.widgetChannels = this.options.dashboardChannelCollection.where({
                dashboard_widget_id: this.options.widget.get('id')
            });
        }

    }

    render() {
        const rawAdvancedConfig = this.options.widget.getParamValue('ADVANCED_CONFIG', false);
        // coerce the raw value -- which may be a boolean, number, or string -- into a boolean
        this.advancedConfig = !!Number(rawAdvancedConfig);

        const rawUseCustomLabelsConfig = this.options.widget.getParamValue('USE_CUSTOM_LABELS', true);
        // coerce the raw value -- which may be a boolean, number, or string -- into a boolean
        this.useCustomLabels = !!Number(rawUseCustomLabelsConfig);

        this.$el.html(this.template({
            layout_modules_url: require('../../../../../../img/widgettypes/layout/modulelayoutsmall.png'),
            organizationCollection: this.options.organizationCollection,
            installCollection: this.options.installCollection,
            widget: this.options.widget,
            isNew: this.options.widget.isNew(),
            advancedConfig: this.advancedConfig,
            useCustomLabels: this.useCustomLabels,
            dashboardCategoriesCollection: this.options.dashboardCategoryCollection,
            dashboardTabCollection: this.options.dashboardTabCollection,
            categoryId: this.options.widget.get('dashboard_category_id') ?
                this.options.widget.get('dashboard_category_id') : this.options.categoryId,
            tabId: this.options.tabId
        }));

        //Initialize bootstrap toggle for advanced configuration
        (<any>this.$el.find('input[type="checkbox"]')).bootstrapToggle();

        if (!this.options.widget.isNew()) {
            this.buildInitialChannels();
            this.handleLayoutInstallSelectChange();
        } else {
            this.renderNewChannelRow();
            setTimeout(() => {
                $('.save').attr('disabled', 'true')
            }, 500);
        }

        return this;
    }

    show() {
        this.$('.tab select').select2(Utils.Select2.defaultOptions);
        this.initializeCategorySelect('.category select');
    }

    handleTabChange(e: JQuery.Event) {
        var $select = this.$('.tab select');
        var rawValue = $select.val();
        var tabId = rawValue === '' || rawValue === null || rawValue === undefined ? null : Number(rawValue);
        this.options.tabId = tabId;
        this.reloadCategoriesForTab(tabId);
    }

    private handleThresholdsInput(e: JQuery.UIEventBase) {
        var targetInput: any = $(e.currentTarget);
        var unit = targetInput.parents('.thresholds').find('.unit').val();

        var val = (<string>targetInput.val());
        var addClass = false;
        if (val == '') {
            val = 'N/A';
        } else {
            if (_.isNaN(Number(val))) {
                val = 'N/A';
            } else {
                val += unit;
                addClass = true;
            }
        }

        var allInputs = targetInput.parents('.thresholds').find('input');
        for (var i = 0; i < allInputs.length; i++) {
            if (allInputs.eq(i).is(targetInput)) break;
        }

        var badge = targetInput.parents('.channel-thresholds').find('.threshold-badges .badge:eq(' + i + ')');
        badge.text(val);
        if (addClass) {
            if (badge.hasClass('crit-low') || badge.hasClass('crit-high')) {
                badge.addClass('danger');
            } else {
                badge.addClass('warning');
            }
        } else {
            badge.removeClass('danger').removeClass('warning');
        }
    }

    private handleLayoutInstallSelectChange() {
        var installId = (Number)($('.widget-layout-select-install').val());
        this.ModuleLayoutCollection = new ModuleLayoutCollection([], installId);

        $.when(
            this.ModuleLayoutCollection.getCollectionFetchPromise(),
        ).then(() => {
            var defVal;
            var selectedLayout = null;
            if (!this.options.widget.isNew() && (this.options.widget.getParamValue('DEFAULT_FLOOR', '') != '')) {
                defVal = (Number)(this.options.widget.getParamValue('DEFAULT_FLOOR', ''))
            }
            var floorSelect = $('.widget-select-floor');
            floorSelect.empty();

            var floorOptions = [{ id: '', text: '' }];
            if (this.ModuleLayoutCollection.models.length) {
                _.each(this.ModuleLayoutCollection.models, (layout) => {
                    var optgroup = { id: layout.get('id'), text: layout.get('name') };
                    if (defVal == layout.get('id')) {
                        selectedLayout = layout
                    }
                    floorOptions.push(<any>optgroup)
                });
            }
            floorSelect.select2(_.extend({
                disabled: !this.ModuleLayoutCollection.models.length,
                data: floorOptions,
            }, Utils.Select2.defaultOptions));
            floorSelect.trigger('change');

            if (!this.options.widget.isNew() && selectedLayout) $(floorSelect).val(selectedLayout.get('id')).trigger('change')
            if (this.ModuleLayoutCollection.models.length) { $('.save').removeAttr('disabled') } else { $('.save').attr('disabled', 'true') }
        });
    }

    private handleThresholdClick(e: JQuery.UIEventBase) {
        var thresholdsContainer = $(e.currentTarget).parents('.channel-thresholds').find('.thresholds');
        var hidden = thresholdsContainer.hasClass('hidden');
        if (hidden) {
            thresholdsContainer.removeClass('hidden');
        } else {
            thresholdsContainer.addClass('hidden');
        }
    }

    private handleChannelDelete(e: JQuery.UIEventBase) {
        var channelContainer = $(e.currentTarget).parents('.channel-selects');
        // Remove elements generated by Spectrum Color Picker
        var colorPickerInputs = channelContainer.find('.threshold-range .threshold-color.color-picker');
        _.each(colorPickerInputs, (cp) => {
            var $cp = $(cp);
            (<any>$cp).spectrum("container").remove();
        });
        channelContainer.remove();
        this.checkCanSaveWidget();
    }

    private handleChannelSelectChange(e: JQuery.UIEventBase) {
        var channelSelect = $(e.currentTarget);
        var container = $(channelSelect).parents('.channel-selects');
        var moduleSelect = container.find('.widget-channel-select-module');
        var moduleNumber = moduleSelect.val();
        var installSelect = container.find('.widget-channel-select-install');
        var useDefaultsButton = container.find('.use-defaults-btn');

        var channelNameInput = container.find('.widget-channel-label').val('');
        var installId = (<string>$(installSelect).val());
        var channelId = Number(channelSelect.val());

        // Clear current ranges
        const thresholdsWrapper = container.find('.thresholds-wrapper');
        thresholdsWrapper.empty();
        const channelThresholdsRow = container.find('.channel-thresholds');
        this.setMultirangeThresholdQty(channelThresholdsRow);
        useDefaultsButton.prop('disabled', true);

        if (!channelId) {
            this.updateThresholdRow(container);
            channelNameInput.prop('disabled', true);
            return;
        }

        // Enable defaults button
        useDefaultsButton.prop('disabled', false);

        var dashbordChannelId = container.find('.widget-dashboard-channel-id').val();
        var dashboardChannel = this.options.dashboardChannelCollection.findWhere({
            dashboard_channel_id: Number(dashbordChannelId),
            dashboard_widget_id: this.options.widget.get('id'),
            channel_id: channelId
        });
        var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
        var channel = module.getChannelById(channelId);
        var unit = channel['channel_unit'];
        var unitField = container.find('.thresholds .unit');

        if (dashboardChannel) {
            channelNameInput.val(dashboardChannel.get('dashboard_channel_name'));
            this.updateThresholdRow(container, channelId, dashboardChannel.get('rangesList'), unit);
        } else {
            this.updateThresholdRow(container, null, null, unit);
        }

        if (channelNameInput.val() == '') {
            channelNameInput.val(module.get('module_location') + ' - ' + channel['channel_name']);
        }

        var chartTitleField = $('.chart-title input');
        if (chartTitleField.val() === '') {
            chartTitleField.val(module.get('module_location') + ' - ' + channel['channel_name']);
        }

        channelNameInput.prop('disabled', false);
        // enable "use defaults" button
        useDefaultsButton.prop('disabled', false);
        
        this.checkCanSaveWidget();
        unitField.val(unit);
    }

    private handleModuleSelectChange(e: JQuery.UIEventBase) {
        var moduleSelect = $(e.currentTarget);
        var moduleNumber = (<string>$(moduleSelect).val()) || "";
        var channelSelect = $(moduleSelect).parents('.channel-selects').find('.widget-channel-select-channel');
        var installSelect = $(moduleSelect).parents('.channel-selects').find('.widget-channel-select-install');
        var installId = (<string>$(installSelect).val());

        // Save this as the last selected module number on the dashboard
        App.setLastSelectedModuleNumber(moduleNumber);

        channelSelect.empty();
        var channelOptions = [{ id: '', text: '' }];
        if (moduleNumber) {
            var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
            if (module) {
                _.each([1, 2, 3, 4], (connector) => {
                    var con = module.getConnector(connector);
                    if (con) {
                        var label = 'Connector ' + connector + ': ' + con['sensor_name'];
                        if (!module.showConnector(connector)) label += ' (disconnected)';

                        var optgroup = { text: label, children: [] };
                        _.each(_.sortBy(con.channels, 'channel_position'), (c) => {
                            optgroup.children.push({ id: c['channel_id'], text: c['channel_name'] });
                        });

                        channelOptions.push(<any>optgroup);
                    }
                });
            }
        }
        channelSelect.select2(_.extend({
            disabled: !moduleNumber.length,
            data: channelOptions,
        }, Utils.Select2.defaultOptions));
        channelSelect.trigger('change');
    }

    private handleInstallSelectChange(e: JQuery.UIEventBase) {
        var installSelect = $(e.currentTarget);
        var installId = Number($(installSelect).val());

        if (!installId) return;

        // Save this as the last selected Id on the dashboard
        App.setLastSelectedInstallId(installId);

        var moduleSelect = installSelect.parents('.channel-selects').find('.widget-channel-select-module');
        moduleSelect.empty();

        if (this.options.permissionCollection.canViewInstall(Number(installId))) {
            if (!_.has(this.options.moduleCollections, installId)) {
                this.options.moduleCollections[installId] = new ModuleCollection([], { installId: installId });
                this.options.moduleCollections[installId].fetch();
            }

            if (this.options.moduleCollections[installId].isFetching()) {
                moduleSelect.append('<option value="">Loading...</option>');

                this.options.moduleCollections[installId].once('sync', () => {
                    moduleSelect.empty().select2(_.extend({
                        disabled: false,
                        data: this.buildModuleOptions(installId),
                    }, Utils.Select2.defaultOptions));
                    moduleSelect.trigger('change');
                });
            } else {
                moduleSelect.select2(_.extend({
                    disabled: !installId,
                    data: this.buildModuleOptions(installId),
                }, Utils.Select2.defaultOptions));
            }
        } else {
            moduleSelect.select2(_.extend({
                disabled: !installId,
            }, Utils.Select2.defaultOptions));
        }

        moduleSelect.trigger('change');
    }

    private handleAddChannelBtnClick(e) {
        e.preventDefault();
        this.renderNewChannelRow();
    }

    private buildModuleOptions(installId) {
        var options = [];
        this.options.moduleCollections[installId].each((module) => {

            // Filter Modules that don't have sensors connected. Control sensors are not
            // Considered sensors in this case
            for (var i = 1; i < 5; i++) {
                var con = module.getConnector(i);
                if (con) {
                    if (con['sensor_type'] === 29) continue;

                    var mod = module.get('module_number');
                    var option = { id: mod, text: module.getDisplayName(), selected: '' };
                    if (mod === App.getLastSelectedModuleNumber()) option.selected = "selected";
                    options.push(option);
                    break;
                }
            }
        });

        if (options.length) return [{ id: '', text: '' }].concat(options);
        return [{ id: '', text: 'No Modules Found' }]
    }

    getSelectedInstallId() {
        return Number(this.$('.widget-layout-select-install').val());
    }

    preSave() {
        var selectedInstallId = this.getSelectedInstallId();
        var install = this.options.installCollection.findWhere({ id: selectedInstallId });
        var size = this.$('.widget-size select').val();
        var defaultFloor;
        if ($('#widget-select-floor').val() != "") {
            defaultFloor = (Number)($('#widget-select-floor').val())
        } else {
            defaultFloor = "";
        }

        this.options.widget.setParamValue('DEFAULT_FLOOR', defaultFloor);
        if ($('.layout-title').val()) this.options.widget.setParamValue('LAYOUT_WIDGET_TITLE', $('.layout-title').val());
        if (selectedInstallId) this.options.widget.setParamValue('LOCATION_ID', selectedInstallId);
        if (install) this.options.widget.setParamValue('LOCATION_NAME', install.get('name'));
        if (size) this.options.widget.setParamValue('WIDGET_SIZE', size);
        this.options.widget.setParamValue('ADVANCED_CONFIG', this.advancedConfig);
        this.options.widget.setParamValue('USE_CUSTOM_LABELS', this.useCustomLabels);
        return true;
    }

    getChannelDifference() {
        var channelsSeen = [];
        var create = [];
        var update = {};
        var rows = this.$('.channel-selects');
        _.each(rows, (row, i) => {
            var $row = $(row);
            var channelId = $row.find('.widget-channel-select-channel').val();

            var dashboardChannelIdField = $row.find('.widget-dashboard-channel-id');
            var dashboardChannelId = Number(dashboardChannelIdField.val());

            if (!channelId) {
                channelId = $row.find('.widget-channel-select-channel').data('channelId');
                if (channelId) channelsSeen.push(dashboardChannelId);
                return;
            }
            channelId = Number(channelId);

            // Use default name or custom name based on configuration
            const installSelect = $row.find('.widget-channel-select-install');
            const installId = (<string>$(installSelect).val());
            const moduleNumber = $row.find('.widget-channel-select-module').val();
            const module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
            const channel = module.getChannelById(channelId);
            let name = (<string>$row.find('.widget-channel-label').val()).trim();
            if(!this.useCustomLabels) name = `${module.get('module_location')} - ${channel['channel_name']}`;

            var rangesList = this.advancedConfig ? this.getRangesListFromAdvancedThresholds(row) : this.getRangesListFromRegularThresholds(row);
            var upsert = {
                dashboardId: this.options.dashboardId,
                widgetId: this.options.widget.get('id'),
                channelId: channelId,
                order: i,
                name: name,
                critLow: null,
                warnLow: null,
                warnHigh: null,
                critHigh: null,
                rangesList: rangesList
            };
            if (dashboardChannelId) {
                channelsSeen.push(dashboardChannelId);

                // Make sure we had permission to update this channel
                if (!dashboardChannelIdField.attr('data-ignore-update')) update[dashboardChannelId] = upsert;
            } else {
                create.push(upsert)
            }
        });

        var _delete = [];
        _.each(this.widgetChannels, (c) => {
            var dcid = c.get('dashboard_channel_id');
            if (!_.includes(channelsSeen, dcid)) _delete.push(dcid);
        });

        return [create, update, _delete]
    }

    checkCanSaveWidget() {
        var savable = _.filter(this.$('.widget-channel-select-channel').map(function () {
            var el = $(this);
            return el.val() || el.data('channelId');
        })).length >= 0;

        this.options.parentView.setSavable(savable);
    }

    private renderNewChannelRow(installId?: number, dashboardChannelOrder?: number, channelsLength?: number) {
        var newChannelRow = $(<string>this.channelsTemplate({
            organizationCollection: this.options.organizationCollection,
            installCollection: this.options.installCollection,
            lastSelectedInstallId: installId || App.getLastSelectedInstallId(),
            advancedConfig: this.advancedConfig,
            useCustomLabels: this.useCustomLabels,
            // Show move up arrow if the channel is not the first or only channel
            showMoveUp: !!(dashboardChannelOrder && channelsLength) || (dashboardChannelOrder && !(dashboardChannelOrder === channelsLength - 1)),
            // Show move down arrow if there is more than one channel and this channel is not the last channel
            showMoveDown: !!(channelsLength > 1 && dashboardChannelOrder < channelsLength - 1)
        }));
        this.$('.channels').append(newChannelRow);

        newChannelRow.find('.widget-channel-select-install').select2(Utils.Select2.defaultOptions);
        newChannelRow.find('.widget-channel-select-module').select2(_.extend({
            disabled: true,
        }, Utils.Select2.defaultOptions));
        newChannelRow.find('.widget-channel-select-channel').select2(_.extend({
            disabled: true,
        }, Utils.Select2.defaultOptions));

        // Immediately trigger a change so that preselected installs cause modules to be fetched
        newChannelRow.find('.widget-channel-select-install').trigger('change');

        // this.setExampleImg();
        this.checkCanSaveWidget();
        return newChannelRow;
    }

    private buildInitialChannels() {
        var widgetId = this.options.widget.get('id');
        var channels: any = _.sortBy(this.options.dashboardChannelCollection.where({ dashboard_widget_id: widgetId }), (dashboardChannel) => {
            return dashboardChannel.get('dashboard_channel_order');
        });

        _.each(channels, (c: DashboardChannel) => {
            var installId = c.get('install_id');
            var dashboardChannelOrder = Number(c.get('dashboard_channel_order'));
            // Use channel's installId, rather than relying on App.getLastSelectedInstallId(), which caused errors
            var row = this.renderNewChannelRow(installId, dashboardChannelOrder, channels.length);

            function selectModuleChannel(row) {
                // Select the module
                row.find('.widget-channel-select-module').val(c.get('module_number')).trigger('change');

                // Select the channel
                row.find('.widget-channel-select-channel').val(c.get('channel_id')).trigger('change');
            }

            // Fill in the Dashboard Channel Id
            row.find('.widget-dashboard-channel-id').val(c.get('dashboard_channel_id'));

            // Select the install
            var installId = c.get('install_id');
            row.find('.widget-channel-select-install').val(installId).trigger('change');

            row.find('.widget-channel-select-channel').data('channelId', c.get('channel_id'));

            var moduleCollectionDeferred = this.options.moduleCollections[installId].getCollectionFetchPromise();
            $.when(moduleCollectionDeferred).done(() => {
                selectModuleChannel(row);
            });
            if (!this.options.moduleCollections[installId]) {
                row.hide();
            }
        });
    }

}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/modify_widgets/layout/ModifyModuleLayoutWidget.ts